import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSupport = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 80" {...props}>
    <path d="M3.47 47.52c2.31 2 2.52 3.07 5.88 3.07 1.62 0 5.71-.53 6.88-1.58A4.78 4.78 0 0 0 18 45.28V26.73A4.81 4.81 0 0 0 16.23 23c-1.18-1-5.26-1.57-6.88-1.57-3.36 0-3.57 1-5.88 3.07A9.68 9.68 0 0 0 0 32v8a9.68 9.68 0 0 0 3.47 7.52M78 50.59h2.89c1.47-.35 1.58-1.48 3.38-3.06A9.71 9.71 0 0 0 87.71 40v-8a9.71 9.71 0 0 0-3.47-7.53c-2.31-2.05-1.6-3.07-5-3.07-1.63 0-5.71.53-6.89 1.57a4.88 4.88 0 0 0-1.78 3.73v18.6a4.37 4.37 0 0 0 2.55 4.18Z" />
    <path d="M45.3 5.14a31.5 31.5 0 0 0-13.67 3 25.47 25.47 0 0 0-10 8.15A18.83 18.83 0 0 0 18 27.43v1.72a1.51 1.51 0 0 1-.59 1.23 2.2 2.2 0 0 1-1.5.48h-2.15a2.24 2.24 0 0 1-1.51-.48 1.51 1.51 0 0 1-.59-1.23v-1.72a24.4 24.4 0 0 1 4.79-13.61 31.7 31.7 0 0 1 11.89-10A37.6 37.6 0 0 1 45.3 0" />
    <path d="M43.39 0a37.46 37.46 0 0 1 17 3.86 31.5 31.5 0 0 1 11.88 10A24.43 24.43 0 0 1 77 27.44v1.71a1.52 1.52 0 0 1-.59 1.24 2.3 2.3 0 0 1-1.51.47h-2.08a2.22 2.22 0 0 1-1.51-.48 1.49 1.49 0 0 1-.6-1.23v-1.72A18.7 18.7 0 0 0 67 16.29a25.33 25.33 0 0 0-10-8.15 31.4 31.4 0 0 0-13.65-3" />
    <ellipse
      cx={60.29}
      cy={72.08}
      rx={9.41}
      ry={6.54}
      transform="rotate(-46.3 60.282 72.07)"
    />
    <path d="m67.81 66.65-3-2L79.18 46l2.56 2ZM64.51 35.29c0 9.63-9.72 27.11-20.05 27.11-10 0-20-17.48-20-27.11s9-19.89 20.05-19.89 20 10.27 20 19.89" />
  </svg>
);
export default SvgSupport;
